import {ITransacton} from "../../types/interfaces";

export const PrepareDataForBankTransaction = (values: any, code?: string, withdrawalStatus?: string) => {

    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const getPaymentType = () => {
        return "international"
    }

    // recipientDetails
    const recipientTempObject = {
        recipientType: values.recipientType ? values.recipientType : null,
        firstName: values.name ? values.name : null,
        lastName: values.surname ? values.surname : null,
        companyName: values.companyName ? values.companyName : null,
        swiftCode: values.recipientsSwiftBic ? values.recipientsSwiftBic : null,
        ibanCode: values.recipientsIban ? values.recipientsIban : null,
        beneficiaryAccountNumber: values.recipientsAccountNumber ? values.recipientsAccountNumber : null,
        beneficiarySortCode: values.sortCode ? values.sortCode : null ,
        beneficiaryAddress: values.recipientsAddress ? values.recipientsAddress : null,
        beneficiaryCountry: values.recipientCountry ? values.recipientCountry : null,
        bankName: values.bankName ? values.bankName : null,
        bankCountry: values.bankCountry ? values.bankCountry : null,
        bankCity: values.bankCity ? values.bankCity : null,
        beneficiaryCity: values.recipientCity ? values.recipientCity : null,
        recipientPostCode: values.recipientPostCode ? values.recipientPostCode : null,
        bankPostCode: values.bankPostCode ? values.bankPostCode : null,
        bankAddress: values.bankAddress ? values.bankAddress : null,
        achRoutingNumber: values.achRoutingNumber ? values.achRoutingNumber : null,
        fedwireRoutingNumber: values.fedwireRoutingNumber ? values.fedwireRoutingNumber : null,
    }

    const testObj = {
        type: getPaymentType(),
        accountId: values.accountId,
        fromAccount: values.hiddenAccountNumberFrom,
        reference: values.reference,
        amount: Number(values.amount),
        currency: values.transferCurrency,
        paymentType: values.paymentRegions?.toLowerCase(),
        invoice: values.invoice.data,
        invoiceFilename: values.invoice.name,
        templateName: values.templateName,
    }

    const preparedForSendObject = {
        ...testObj,
        recipientDetails: recipientTempObject,
        withdrawalCode: code,
        twoFaCode: values.twoFaCode,
        userTimezone: timezone,
    }

    return preparedForSendObject
}

